'use client'

// src/context/useAnalytics.ts
import { useContext } from "react";

// src/context/context.tsx
import { createContext } from "react";
var analyticsContext = createContext({
  showConsent: false,
  loginEvent: () => {
  },
  signupEvent: () => {
  },
  setUser: () => {
  },
  logoutEvent: () => {
  },
  viewItemEvent: () => {
  },
  viewItemListEvent: () => {
  },
  generateLeadEvent: () => {
  },
  viewItemBook: () => {
  },
  viewSummaryEvent: () => {
  },
  ticketsSummaryEvent: () => {
  },
  paymentSummaryEvent: () => {
  },
  cartEvent: () => {
  },
  clearCart: () => {
  },
  beginCheckout: () => {
  },
  purchaseEvent: () => {
  },
  purchaseSubscriptionEvent: () => {
  },
  purchaseFailed: () => {
  },
  shareEvent: () => {
  },
  setCookieConsent: () => {
  },
  pageView: () => {
  },
  registerInterestEvent: () => {
  },
  newsletterEvent: () => {
  },
  trackEvent: () => {
  }
});
var context_default = analyticsContext;

// src/context/useAnalytics.ts
var useAnalytics = () => {
  const context = useContext(context_default);
  if (!context) {
    throw new Error("useAnalytics must be used within an AnalyticsProvider");
  }
  return context;
};
var useAnalytics_default = useAnalytics;

export {
  context_default,
  useAnalytics_default
};
//# sourceMappingURL=chunk-XDJBAJOL.mjs.map